import React, { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { postLoginPath } from '../../utils/postLoginPath';
import logoWhite from '../../Images/LOGO.png';
import brandBackground from '../../Images/wallpaper_for_a_web_application.jpg';
import RouteLoading from '../Content/RouteLoading';
import './PublicLayout.css';

export default function PublicLayout() {
  const { user, accounts, backoffice, platformAdmin, canAccessAllAccounts } =
    useAuth();

  if (user) {
    return (
      <Navigate
        to={postLoginPath({
          accounts,
          backoffice,
          platformAdmin,
          canAccessAllAccounts,
          lastAccountId: user?.attributes?.['custom:hubspotid'],
        })}
        replace
      />
    );
  }

  return (
    <div className="auth-shell">
      <aside
        className="auth-brand"
        style={{ backgroundImage: `url(${brandBackground})` }}
      >
        <div className="auth-brand__content">
          <img
            className="auth-brand__logo"
            src={logoWhite}
            alt="nua"
          />
          <p className="auth-brand__subtitle">
            Hazlo simple, hazlo con nua
          </p>
          <span className="auth-brand__accent" aria-hidden="true" />
        </div>
      </aside>

      <main className="auth-form">
        <div className="auth-form__inner">
          <Suspense fallback={<RouteLoading compact />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  );
}
